// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";

type SoftwareUpdateType = {
  title: string;
};

const SoftwareUpdate = ({ title }: SoftwareUpdateType) => {
  const { t } = useTranslation("operating-manual");

  return (
    <OperatingManualContent title={title}>
      <Typography>
        {t(
          "A web browser and a stable internet connection of ~ 10 Mb download, and ~ 5 Mb upload speed is required to access the RetinaLogik portal."
        )}
      </Typography>

      <Typography>
        {t(
          "RetinaLogik will remotely push software updates to both the virtual reality headset and the RetinaLogik Portal. Customers will be notified about virtual reality application updates as they are available. This operating manual reflects version 5.22 of the virtual reality application."
        )}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          mx: "20px",
        }}
      >
        <Typography>
          1.{" "}
          <span style={{ color: "#0066CC", fontWeight: 600 }}>
            {t("Virtual Reality Headset")}:
          </span>{" "}
          {t(
            "To update the virtual reality headset, the device will need to be turned on and connected to the internet for 25 minutes."
          )}
        </Typography>
        <Typography>
          2.{" "}
          <span style={{ color: "#0066CC", fontWeight: 600 }}>
            {t("Portal")}:
          </span>{" "}
          {t(
            "The portal will automatically be updated. For best results, please clear your cache in your browser settings when a new update is pushed."
          )}
        </Typography>
      </Box>
    </OperatingManualContent>
  );
};

export default SoftwareUpdate;
